import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { Button } from 'antd';

import Logo from 'components/Login/Logo';

import {
  Page,
  LogoContainer,
  Content,
  Card,
  Heading,
  Status,
  Title,
  Message,
  Actions,
} from './styled';

/**
 * Error page shown when the /connect-chat bridge POST fails. Reads a `status`
 * query param set by ConnectChat's catch handler and renders a tailored message
 * for the recoverable cases (403 = MCP access not licensed).
 */
const ConnectChatError = () => {
  const location = useLocation();
  const status = new URLSearchParams(location.search).get('status');

  const isNotLicensed = status === '403';

  // Mirrors useFreshChat: the widget lives on window once the wrapper has
  // loaded it, and this route renders inside FreshChatWrapper.
  const openLiveChat = useCallback(() => {
    const { fcWidget } = window;
    if (fcWidget && !fcWidget.isOpen()) fcWidget.open();
  }, []);

  const label = isNotLicensed ? 'Access not enabled' : 'Connection failed';

  const title = isNotLicensed
    ? 'MCP access is not enabled for your account'
    : 'We could not connect your chat host to SciLeads';

  const message = isNotLicensed
    ? 'Your SciLeads license does not currently include access to the MCP connector. Your account administrator can request it for you, or contact support and we will help.'
    : 'Something went wrong while setting up the connection. Nothing has been changed on your account. Try connecting again from your chat host, and contact support if it keeps failing.';

  return (
    <Page>
      <LogoContainer>
        <Logo />
      </LogoContainer>
      <Content>
        <Card>
          <Heading>
            <Status $warning={isNotLicensed}>{label}</Status>
            <Title>{title}</Title>
          </Heading>
          <Message>{message}</Message>
          <Actions>
            <Button type='primary' href='/'>
              Back to SciLeads
            </Button>
            <Button onClick={openLiveChat}>Contact support</Button>
          </Actions>
        </Card>
      </Content>
    </Page>
  );
};

export default ConnectChatError;
